import { render, staticRenderFns } from "./shipbox.vue?vue&type=template&id=849f0470&scoped=true"
import script from "./shipbox.vue?vue&type=script&lang=js"
export * from "./shipbox.vue?vue&type=script&lang=js"
import style0 from "./shipbox.vue?vue&type=style&index=0&id=849f0470&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849f0470",
  null
  
)

export default component.exports